(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
const addVideoParameter = (source, parameter) => {
  if (!source || source.includes(`${parameter.split('=')[0]}=`)) return source;
  return `${source}${source.includes('?') ? '&' : '?'}${parameter}`;
};

const startIframeVideo = (media, muted) => {
  const iframe = media.querySelector('iframe');
  if (!iframe) return false;

  const provider = media.dataset.videoProvider;
  let source = addVideoParameter(iframe.getAttribute('src'), 'autoplay=1');

  if (muted) {
    source = addVideoParameter(source, provider === 'vimeo' ? 'muted=1' : 'mute=1');
  }

  iframe.setAttribute('src', source);
  return true;
};

const initVideoReviewAutoplay = (scope) => {
  const mediaItems = scope.querySelectorAll('[data-video-autoplay]:not([data-video-autoplay-ready])');
  if (!mediaItems.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    mediaItems.forEach((media) => {
      media.querySelector('video')?.play().catch(() => {});
      startIframeVideo(media, true);
      media.setAttribute('data-video-autoplay-ready', '');
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const media = entry.target;
      const video = media.querySelector('video');

      if (video) {
        video.play().catch(() => {});
      } else {
        startIframeVideo(media, true);
      }

      observer.unobserve(media);
    });
  }, { threshold: 0.1 });

  mediaItems.forEach((media) => {
    media.setAttribute('data-video-autoplay-ready', '');
    observer.observe(media);
  });
};

const initVideoReviewPlayButtons = (scope) => {
  scope.querySelectorAll('[data-video-review-play]:not([data-video-play-ready])').forEach((button) => {
    button.setAttribute('data-video-play-ready', '');
    button.addEventListener('click', () => {
      const media = button.closest('[data-video-click-to-play]');
      const video = media?.querySelector('video');
      if (!media) return;

      media.classList.add('is-playing');

      if (video) {
        video.controls = true;
        video.play().catch(() => {
          video.controls = false;
          media.classList.remove('is-playing');
        });
      } else if (!startIframeVideo(media, false)) {
        media.classList.remove('is-playing');
      }
    });
  });
};

const initVideoReviews = (scope = document) => {
  initVideoReviewAutoplay(scope);
  initVideoReviewPlayButtons(scope);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVideoReviews());
} else {
  initVideoReviews();
}

document.addEventListener('shopify:section:load', (event) => initVideoReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
